import request from '@/utils/request'

export default {
  // 获取广告底部菜单列表
  getMenuAdBottomList(data) {
    return request({
      url: `/emi/menu/adBottomMenu/list`,
      method: 'post',
      data
    })
  },
  // 底部菜单详情
  fetchMenuAdBottomMenuInfo(data) {
    return request({
      url: `/emi/menu/adBottomMenuInfo`,
      method: 'post',
      data
    })
  },
  // 获取右侧悬浮菜单列表
  getMenuAdRightList(data) {
    return request({
      url: `/emi/menu/adRightMenu/list`,
      method: 'post',
      data
    })
  },
  // 获取右侧悬浮菜单详情
  getMenuAdRightMenuInfo(data) {
    return request({
      url: `/emi/menu/adRightMenu/info`,
      method: 'post',
      data
    })
  },
  // 底部菜单上下架
  fetchAdBottomMenuStatus(data) {
    return request({
      url: `/emi/menu/adBottomMenu/updateStatus`,
      method: 'post',
      data
    })
  },
  // 右侧悬浮菜单上下架
  fetchAdRightMenuStatus(data) {
    return request({
      url: `/emi/menu/adRightMenu/updateStatus`,
      method: 'post',
      data,
      hideLoading: true
    })
  },
  // 获取上架药品
  featchAdRightMenuDrug(data) {
    return request({
      url: `/emi/menu/adRightMenu/drug`,
      method: 'post',
      data,
      hideLoading: true
    })
  },
  // 底部菜单上下架
  fetchAdBottomMenuSort(data) {
    return request({
      url: `/emi/menu/adBottomMenu/sort`,
      method: 'post',
      data
    })
  },
  // 右侧悬浮菜单排序
  fetchAdRightMenuSort(data) {
    return request({
      url: `/emi/menu/adRightMenu/sort`,
      method: 'post',
      data
    })
  },
  // 删除底部菜单
  fetchAdBottomMenuDelete(data) {
    return request({
      url: `/emi/menu/adBottomMenu/delete`,
      method: 'post',
      data
    })
  },
  // 删除右侧悬浮菜单
  fetchAdRightMenuDelete(data) {
    return request({
      url: `/emi/menu/adRightMenu/delete`,
      method: 'post',
      data
    })
  },
  // 添加底部菜单
  fetchAdBottomMenuAdd(data) {
    return request({
      url: `/emi/menu/adBottomMenu/add`,
      method: 'post',
      data
    })
  },
  // 添加右侧悬浮菜单
  fetchAdRightMenuAdd(data) {
    return request({
      url: `/emi/menu/adRightMenu/add`,
      method: 'post',
      data
    })
  },
  // 修改底部菜单
  fetchAdBottomMenuUpdate(data) {
    return request({
      url: `/emi/menu/adBottomMenu/update`,
      method: 'post',
      data
    })
  },
  // 添加广告名称校验 true校验通过，false校验失败
  fetchAddCheckName(data) {
    return request({
      url: `/emi/menu/add/checkName`,
      method: 'post',
      data,
      hideLoading: true
    })
  },
  // 获取绑定的药品信息
  getAdDrugList(data) {
    return request({
      url: `/emi/ad/drug/list`,
      method: 'POST',
      data,
      hideLoading: true
    })
  },
  // 修改右侧悬浮菜单
  fetchAdRightMenuUpdate(data) {
    return request({
      url: `/emi/menu/adRightMenu/update`,
      method: 'post',
      data
    })
  },
  // 获取字典列表
  fetchSysDictList(data) {
    return request({
      url: `/emi/sysDict/list`,
      method: 'post',
      data
    })
  },
  // 获取广告列表
  fetchAdList(data) {
    return request({
      url: `/emi/ad/list`,
      method: 'post',
      data
    })
  },
  // 删除广告
  fetchAdDelete(data) {
    return request({
      url: `/emi/ad/delete`,
      method: 'post',
      data
    })
  },
  // 上下架
  fetchAdStatus(data) {
    return request({
      url: `/emi/ad/status`,
      method: 'post',
      data
    })
  },
  // 上下架校验
  fetchAdOnCheck(data) {
    return request({
      url: `/emi/ad/onCheck`,
      method: 'post',
      data
    })
  },
  // 编辑广告
  fetchAdUpdate(data) {
    return request({
      url: `/emi/ad/update`,
      method: 'post',
      data
    })
  },
  // 广告详情
  fetchAdDetail(data) {
    return request({
      url: `/emi/ad/detail`,
      method: 'post',
      data
    })
  },
  // 添加广告
  fetchAdAdd(data) {
    return request({
      url: `/emi/ad/add`,
      method: 'post',
      data
    })
  },
  // 删除绑定药品
  fetchAdDeleteDrug(data) {
    return request({
      url: `/emi/ad/deleteDrug`,
      method: 'post',
      data
    })
  },
  // 混合搜索 通用名 批准文号
  fetchAdMixSearch(data) {
    return request({
      url: `/emi/ad/mixSearch`,
      method: 'post',
      data
    })
  },
  // 混新增时获取广告编码
  fetchAdGetAdCode(data) {
    return request({
      url: `/emi/ad/getAdCode`,
      method: 'post',
      data
    })
  },
  // 已选择的药品
  fetchAdSelectedDrug(data) {
    return request({
      url: `/emi/ad/selectedDrug`,
      method: 'post',
      data
    })
  },
  // 修改药品
  fetchAdModifyDrug(data) {
    return request({
      url: `/emi/ad/modifyDrug`,
      method: 'post',
      data
    })
  },
  // 删除adCode
  fetchAdCancel(data) {
    return request({
      url: `/emi/ad/cancel`,
      method: 'post',
      data,
      hideLoading: true
    })
  },
}
